import React from 'react'
import MuiPhoneNumber from 'material-ui-phone-number'
import styles from '../agreementStyles/agreementStyle.module.css'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import {CreateAgreementStep2PropDataType, furnitureDataType} from '../agreementDataType'
import {ToWords} from 'to-words'

const CreateAgreementStep2 = ({
  formik,
  province,
  furnitureInitialFields,
  setFurnitureInitialFields,
  agreementGeneratedDate,
  setAgreementGeneratedDate,
  agreementStartDate,
  setAgreementStartDate,
  agreementEndDate,
  setAgreementEndDate,
}: CreateAgreementStep2PropDataType) => {
  const toWords = new ToWords()

  // cretaed array to show rent days from 1-31
  const rentDay = Array.from({length: 31}, (_, index) => index + 1)

  // function to hundle the room
  const handleAddRooms = () => {
    setFurnitureInitialFields((prevFurnitureInitialFields: furnitureDataType[]) => [
      ...prevFurnitureInitialFields,
      {
        room_name: '',
        room_details: '',
      },
    ])
    formik.setFieldValue(
      `furnished_room_details`,
      [
        ...formik.values.furnished_room_details,
        {
          room_name: '',
          room_details: '',
        },
      ],
      true
    )
  }

  // function to delete the room
  const handleDeleteRoom = (i: number) => {
    setFurnitureInitialFields((prevFurnitureInitialFields: furnitureDataType[]) =>
      prevFurnitureInitialFields.filter((_, index: number) => index !== i)
    )
    const updatedArray = formik.values.furnished_room_details.filter(
      (_: any, index: number) => index !== i
    )
    formik.setFieldValue(`furnished_room_details`, updatedArray, true)
  }

  // function to format the date
  const formatDate = (dateString: Date) => {
    const date = new Date(dateString)
    // Format the date to "05 August 2024" format
    const formattedDate = date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })
    return formattedDate
  }
  return (
    <div className='card mb-5 mb-xl-10 w-100 p-5'>
      {/*Begin: Property details section */}
      {/* Begin: Heading */}
      <h2 className='text-center page-heading text-primary fw-bold fs-3 mb-4 pt-2'>
        Property Details
      </h2>
      {/* End: Heading */}
      {/*Begin::Form Group Property short description */}
      <div className='fv-row mb-2 w-100'>
        <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
          <span className='required'>Property Short Description</span>
          <i
            className='fas fa-exclamation-circle ms-2 fs-7'
            data-bs-toggle='tooltip'
            title='Enter short description about property'
          ></i>
        </label>
        <textarea
          className='form-control form-control-lg form-control-solid'
          placeholder='Enter property short description'
          {...formik.getFieldProps('property_short_description')}
          name='property_short_description'
        />
        <div className='h-20px'>
          {formik.touched.property_short_description &&
            formik.errors.property_short_description && (
              <div className='fv-help-block color-red'>
                {formik.errors.property_short_description}
              </div>
            )}
        </div>
      </div>
      {/*end::Form Group Property short description */}

      {/* Begin: Form Group List of furniture */}
      <div className='collapse show w-100'>
        <div className='card-body px-2 py-0 fv-row'>
          <span className='d-flex'>
            <h3 className='fw-bold mb-2 text-primary fs-4'>List of furniture</h3>
            <span className='mb-2 text-primary'>&nbsp;(optional)</span>
          </span>
          <div className='row my-2'>
            {furnitureInitialFields.map((room, index: number) => {
              return (
                <div className='col-lg-6 mb-5'>
                  <div className='border border-1 border-primary border-dashed rounded p-3 px-7 position-relative'>
                    <i
                      className='bi bi-x-circle-fill fs-2 position-absolute top-0 end-0 text-primary'
                      onClick={() => handleDeleteRoom(index)}
                    ></i>
                    <div className='mb-1 '>
                      <span className='text-dark fw-bolder d-block fs-4 mb-2'>{`Room ${
                        index + 1
                      }`}</span>
                      <hr />
                      {/*Begin::Form Group Room Name*/}
                      <div className='fv-row ml-8'>
                        <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                          <span className='required'>Room Name</span>
                          <i
                            className='fas fa-exclamation-circle ms-2 fs-7'
                            data-bs-toggle='tooltip'
                            title='Enter room name'
                          ></i>
                        </label>
                        <input
                          type='text'
                          className='form-control form-control-lg form-control-solid'
                          name={`furnished_room_details[${index}].room_name`}
                          placeholder='Enter room name'
                          {...formik.getFieldProps(`furnished_room_details[${index}].room_name`)}
                        />
                        <div className='h-20px'>
                          {formik.touched.furnished_room_details &&
                            formik.touched.furnished_room_details[index] &&
                            formik.touched.furnished_room_details[index].room_name &&
                            formik.errors.furnished_room_details &&
                            formik.errors.furnished_room_details[index] &&
                            formik.errors.furnished_room_details[index].room_name && (
                              <div className='fv-help-block color-red'>
                                {formik.errors.furnished_room_details[index].room_name}
                              </div>
                            )}
                        </div>
                      </div>
                      {/*End::Form Group Room Name*/}
                      {/*Begin::Form Group Room details*/}
                      <div className='fv-row mb-3 ml-8'>
                        <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                          <span className='required'>Furniture details</span>
                          <i
                            className='fas fa-exclamation-circle ms-2 fs-7'
                            data-bs-toggle='tooltip'
                            title='Enter room furniture details e.g. Glass/wooden Cabinet fixed on the wall'
                          ></i>
                        </label>
                        <input
                          type='text'
                          className='form-control form-control-lg form-control-solid'
                          name={`furnished_room_details[${index}].room_details`}
                          placeholder='Enter furniture details'
                          {...formik.getFieldProps(`furnished_room_details[${index}].room_details`)}
                        />
                        <div className='h-20px'>
                          {formik.touched.furnished_room_details &&
                            formik.touched.furnished_room_details[index] &&
                            formik.touched.furnished_room_details[index].room_details &&
                            formik.errors.furnished_room_details &&
                            formik.errors.furnished_room_details[index] &&
                            formik.errors.furnished_room_details[index].room_details && (
                              <div className='fv-help-block color-red'>
                                {formik.errors.furnished_room_details[index].room_details}
                              </div>
                            )}
                        </div>
                      </div>
                      {/*End::Form Group Room details*/}
                    </div>
                  </div>
                </div>
              )
            })}
            <div className='col-lg-6 mb-5'>
              {/* <div className='d-flex flex-column align-items-center justify-content-start'> */}
              <button
                type='button'
                className={`d-flex align-items-center py-2 px-4 rounded btn ${
                  furnitureInitialFields.length >= 6 ? 'btn-secondary' : 'btn-primary'
                }`}
                onClick={handleAddRooms}
                disabled={furnitureInitialFields.length >= 6}
              >
                <span>
                  <i className='bi bi-plus-circle fs-2 text-light pt-2 ps-0'></i>
                </span>
                <span className='text-light'>Add room furniture details</span>
              </button>
              <p className='text-muted fw-bold mb-0 px-7'>
                {`${furnitureInitialFields.length}/6 Rooms added`}
              </p>
            </div>
          </div>
        </div>
        {/* End: signers */}
      </div>
      {/* End: Form Group List of furniture */}

      {/* Begin: Property address */}
      <div className='d-flex justify-content-between w-100 flex-wrap'>
        {/*Begin::Form Group Address Line 1 */}
        <div className={`fv-row mb-2 ${styles.max_w_48}`}>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span className='required'>Address Line 1</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Enter property address'
            ></i>
          </label>
          <textarea
            className='form-control form-control-lg form-control-solid'
            placeholder='Enter property address'
            {...formik.getFieldProps('property_address_1')}
            name='property_address_1'
          />
          <div className='h-20px'>
            {formik.touched.property_address_1 && formik.errors.property_address_1 && (
              <div className='fv-help-block color-red'>{formik.errors.property_address_1}</div>
            )}
          </div>
        </div>
        {/*end::Form Group Address Line 1 */}
        {/*Begin::Form Group Address Line 2*/}
        <div className={`fv-row mb-2 ${styles.max_w_48}`}>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span className='required'>Address Line 2</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Enter property address'
            ></i>
          </label>
          <textarea
            className='form-control form-control-lg form-control-solid'
            placeholder='Enter property address'
            {...formik.getFieldProps('property_address_2')}
            name='property_address_2'
          />
          <div className='h-20px'>
            {formik.touched.property_address_2 && formik.errors.property_address_2 && (
              <div className='fv-help-block color-red'>{formik.errors.property_address_2}</div>
            )}
          </div>
        </div>
        {/*end::Form Group Address Line 2*/}
        {/*Begin::Form Group Province/State*/}
        <div className={`fv-row mb-2 ${styles.max_w_48}`}>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span className='required'>Province/State</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Choose province/state for the property'
            ></i>
          </label>
          <select
            className='form-select form-select-solid'
            placeholder='Select province/state'
            {...formik.getFieldProps('property_address_state')}
            name='property_address_state'
          >
            <option className='bg-color-gray' value=''>
              Select province/state
            </option>
            {province.map((item) => {
              return (
                <option key={item.province_id} value={item.province_name}>
                  {item.province_name}
                </option>
              )
            })}
          </select>
          <div className='h-20px'>
            {formik.touched.property_address_state && formik.errors.property_address_state && (
              <div className='fv-help-block color-red'>{formik.errors.property_address_state}</div>
            )}
          </div>
        </div>
        {/*end::Form Group Province/State*/}
        {/*Begin::Form Group city*/}
        <div className={`fv-row mb-2 ${styles.max_w_48}`}>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span className='required'>City</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Enter city for the property'
            ></i>
          </label>
          <input
            type='text'
            className='form-control form-control-lg form-control-solid'
            placeholder='Enter city'
            {...formik.getFieldProps('property_address_city')}
            name='property_address_city'
          />
          <div className='h-20px'>
            {formik.touched.property_address_city && formik.errors.property_address_city && (
              <div className='fv-help-block color-red'>{formik.errors.property_address_city}</div>
            )}
          </div>
        </div>
        {/*end::Form Group city*/}
        {/*Begin::Form Group PIN/Postcode*/}
        <div className={`fv-row mb-2 ${styles.max_w_48}`}>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span className='required'>PIN/Postcode</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Enter pincode for the property'
            ></i>
          </label>
          <input
            type='text'
            className='form-control form-control-lg form-control-solid'
            placeholder='Enter PIN/Postcode'
            {...formik.getFieldProps('property_address_pincode')}
            name='property_address_pincode'
          />
          <div className='h-20px'>
            {formik.touched.property_address_pincode && formik.errors.property_address_pincode && (
              <div className='fv-help-block color-red'>
                {formik.errors.property_address_pincode}
              </div>
            )}
          </div>
        </div>
        {/*end::Form Group PIN/Postcode*/}
      </div>
      {/* End: Property address */}
      {/*End: Property details section */}

      <hr className='py-2 text-primary' />

      {/* Begin: Account Details */}
      <h2 className='text-center page-heading text-primary fw-bold fs-3 mb-5'>Account Details</h2>
      <div className='d-flex justify-content-between w-100 flex-wrap'>
        <div className={`d-flex justify-content-between w-100 flex-wrap ${styles.max_w_48}`}>
          {/*Begin::Form Group account_holder_courtesy_titles */}
          <div className={`fv-row mb-2 ${styles.max_w_24}`}>
            <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
              <span className='required'>Title</span>
            </label>
            <select
              className='form-select form-select-solid'
              placeholder='Enter account holder courtesy title'
              {...formik.getFieldProps('account_holder_courtesy_titles')}
              name='account_holder_courtesy_titles'
            >
              <option className='bg-color-gray' value=''>
                Select
              </option>
              <option value='Miss'>Miss</option>
              <option value='Mr'>Mr</option>
              <option value='Mrs'>Mrs</option>
              <option value='Ms'>Ms</option>
              <option value='Mx'>Mx</option>
            </select>
            <div className='h-20px'>
              {formik.touched.account_holder_courtesy_titles &&
                formik.errors.account_holder_courtesy_titles && (
                  <div className='fv-help-block color-red'>
                    {formik.errors.account_holder_courtesy_titles}
                  </div>
                )}
            </div>
          </div>
          {/*end::Form Group account_holder_courtesy_titles */}
          {/*Begin::Form Group Account holder name */}
          <div className={`fv-row mb-2 ${styles.max_w_75}`}>
            <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
              <span className='required'>Account holder name</span>
              <i
                className='fas fa-exclamation-circle ms-2 fs-7'
                data-bs-toggle='tooltip'
                title='Enter account holder name'
              ></i>
            </label>
            <input
              type='text'
              className='form-control form-control-lg form-control-solid'
              placeholder='Enter account holder name'
              {...formik.getFieldProps('account_holder_name')}
              name='account_holder_name'
            />
            <div className='h-20px'>
              {formik.touched.account_holder_name && formik.errors.account_holder_name && (
                <div className='fv-help-block color-red'>{formik.errors.account_holder_name}</div>
              )}
            </div>
          </div>
          {/*end::Form Group Account holder name */}
        </div>
        {/*Begin::Form Group Account holder PAN number*/}
        <div className={`fv-row mb-2 ${styles.max_w_48}`}>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span className='required'>Account Holder PAN Number</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Enter account holder PAN number'
            ></i>
          </label>
          <input
            type='text'
            className='form-control form-control-lg form-control-solid'
            placeholder='Enter account holder PAN number'
            {...formik.getFieldProps('account_holder_pan')}
            name='account_holder_pan'
          />
          <div className='h-20px'>
            {formik.touched.account_holder_pan && formik.errors.account_holder_pan && (
              <div className='fv-help-block color-red'>{formik.errors.account_holder_pan}</div>
            )}
          </div>
        </div>
        {/*end::Form Group Account holder PAN number*/}
        {/*Begin::Form Group account number*/}
        <div className={`fv-row mb-2 ${styles.max_w_48}`}>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span className='required'>Acccount Number</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Enter account number'
            ></i>
          </label>
          <input
            type='text'
            className='form-control form-control-lg form-control-solid'
            placeholder='Enter account number'
            {...formik.getFieldProps('account_number')}
            name='account_number'
          />
          <div className='h-20px'>
            {formik.touched.account_number && formik.errors.account_number && (
              <div className='fv-help-block color-red'>{formik.errors.account_number}</div>
            )}
          </div>
        </div>
        {/*end::Form Group account number*/}
        {/*Begin::Form Group Bank name*/}
        <div className={`fv-row mb-2 ${styles.max_w_48}`}>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span className='required'>Bank Name</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Enter bank name'
            ></i>
          </label>
          <input
            type='text'
            className='form-control form-control-lg form-control-solid'
            placeholder='Enter bank name'
            {...formik.getFieldProps('account_bank_name')}
            name='account_bank_name'
          />
          <div className='h-20px'>
            {formik.touched.account_bank_name && formik.errors.account_bank_name && (
              <div className='fv-help-block color-red'>{formik.errors.account_bank_name}</div>
            )}
          </div>
        </div>
        {/*end::Form Group Bank name*/}
        {/*Begin::Form Group account bank branch name*/}
        <div className={`fv-row mb-2 ${styles.max_w_48}`}>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span className='required'>Bank Branch Name</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Enter bank branch name'
            ></i>
          </label>
          <input
            type='text'
            className='form-control form-control-lg form-control-solid'
            placeholder='Enter bank branch name'
            {...formik.getFieldProps('account_bank_branch_name')}
            name='account_bank_branch_name'
          />
          <div className='h-20px'>
            {formik.touched.account_bank_branch_name && formik.errors.account_bank_branch_name && (
              <div className='fv-help-block color-red'>
                {formik.errors.account_bank_branch_name}
              </div>
            )}
          </div>
        </div>
        {/*end::Form Group account bank branch name*/}
        {/*Begin::Form Group account bank ifsc*/}
        <div className={`fv-row mb-2 ${styles.max_w_48}`}>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span className='required'>Bank IFSC Number</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Enter bank IFSC number'
            ></i>
          </label>
          <input
            type='text'
            className='form-control form-control-lg form-control-solid'
            placeholder='Enter bank IFSC number'
            {...formik.getFieldProps('account_bank_ifsc')}
            name='account_bank_ifsc'
          />
          <div className='h-20px'>
            {formik.touched.account_bank_ifsc && formik.errors.account_bank_ifsc && (
              <div className='fv-help-block color-red'>{formik.errors.account_bank_ifsc}</div>
            )}
          </div>
        </div>
        {/*end::Form Group account bank ifsc*/}
      </div>
      {/* End: Account Details */}

      <hr className='py-2 text-primary' />

      {/* Begin: Rent and Agreement Details */}
      <h2 className='text-center page-heading text-primary fw-bold fs-3 mb-5'>
        Rent and Agreement Details
      </h2>
      <div className='d-flex justify-content-between w-100 flex-wrap'>
        {/*Begin::Form Group property rent monthly amount */}
        <div className={`fv-row mb-2 ${styles.max_w_48}`}>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span className='required'>Monthly Rent Amount</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Enter monthly rent amount'
            ></i>
          </label>
          <input
            type='text'
            className='form-control form-control-lg form-control-solid'
            placeholder='Enter monthly rent amount'
            {...formik.getFieldProps('property_rent_monthly_amount')}
            name='property_rent_monthly_amount'
            onChange={(e) => {
              formik.setFieldValue('property_rent_monthly_amount', e.target.value, true)
              if (e.target.value === '') {
                formik.setFieldValue('property_rent_monthly_amount_words', '', true)
              } else {
                formik.setFieldValue(
                  'property_rent_monthly_amount_words',
                  toWords.convert(parseInt(e.target.value, 10), {ignoreDecimal: true}),
                  true
                )
              }
            }}
          />
          <div className='h-20px'>
            {formik.touched.property_rent_monthly_amount &&
              formik.errors.property_rent_monthly_amount && (
                <div className='fv-help-block color-red'>
                  {formik.errors.property_rent_monthly_amount}
                </div>
              )}
          </div>
        </div>
        {/*end::Form Group property rent monthly amount */}
        {/*Begin::Form Group property rent monthly amount words*/}
        <div className={`fv-row mb-2 ${styles.max_w_48}`}>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span className='required'>Monthly Rent Amount In Words</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Enter monthly rent amount in words'
            ></i>
          </label>
          <input
            type='text'
            className='form-control form-control-lg form-control-solid'
            placeholder='Enter monthly rent amount in words'
            {...formik.getFieldProps('property_rent_monthly_amount_words')}
            name='property_rent_monthly_amount_words'
          />
          <div className='h-20px'>
            {formik.touched.property_rent_monthly_amount_words &&
              formik.errors.property_rent_monthly_amount_words && (
                <div className='fv-help-block color-red'>
                  {formik.errors.property_rent_monthly_amount_words}
                </div>
              )}
          </div>
        </div>
        {/*end::Form Group property rent monthly amount words*/}
        {/*Begin::Form Group property advance amount*/}
        <div className={`fv-row mb-2 ${styles.max_w_48}`}>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span className='required'>Advance Amount</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Enter advance amount'
            ></i>
          </label>
          <input
            type='text'
            className='form-control form-control-lg form-control-solid'
            placeholder='Enter advance amount'
            {...formik.getFieldProps('property_advance_amount')}
            name='property_advance_amount'
            onChange={(e) => {
              formik.setFieldValue('property_advance_amount', e.target.value, true)
              if (e.target.value === '') {
                formik.setFieldValue('property_advance_amount_words', '', true)
              } else {
                formik.setFieldValue(
                  'property_advance_amount_words',
                  toWords.convert(parseInt(e.target.value, 10), {ignoreDecimal: true}),
                  true
                )
              }
            }}
          />
          <div className='h-20px'>
            {formik.touched.property_advance_amount && formik.errors.property_advance_amount && (
              <div className='fv-help-block color-red'>{formik.errors.property_advance_amount}</div>
            )}
          </div>
        </div>
        {/*end::Form Group property advance amount*/}
        {/*Begin::Form Group property advance amount words*/}
        <div className={`fv-row mb-2 ${styles.max_w_48}`}>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span className='required'>Advance Amount In Words</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Enter advance amount in words'
            ></i>
          </label>
          <input
            type='text'
            className='form-control form-control-lg form-control-solid'
            placeholder='Enter advance amount in words'
            {...formik.getFieldProps('property_advance_amount_words')}
            name='property_advance_amount_words'
          />
          <div className='h-20px'>
            {formik.touched.property_advance_amount_words &&
              formik.errors.property_advance_amount_words && (
                <div className='fv-help-block color-red'>
                  {formik.errors.property_advance_amount_words}
                </div>
              )}
          </div>
        </div>
        {/*end::Form Group property advance amount words*/}
        {/*Begin::Form Group Property Rent Day*/}
        <div className={`fv-row mb-2 ${styles.max_w_48}`}>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span className='required'>Property Rent Day</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Enter property rent day'
            ></i>
          </label>
          <select
            className='form-select form-select-solid px-3'
            placeholder='Enter property rent day'
            {...formik.getFieldProps('property_rent_day')}
            name='property_rent_day'
          >
            <option className='bg-color-gray' value=''>
              Select rent day
            </option>
            {rentDay.map((item: any) => {
              return (
                <option key={item} value={item}>
                  {item}
                </option>
              )
            })}
          </select>
          <div className='h-20px'>
            {formik.touched.property_rent_day && formik.errors.property_rent_day && (
              <div className='fv-help-block color-red'>{formik.errors.property_rent_day}</div>
            )}
          </div>
        </div>
        {/*end::Form Group Property Rent Day*/}
        {/*Begin::Form Group Agreement Generated Date*/}
        <div className={`fv-row mb-2 ${styles.max_w_48}`}>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span className='required'>Agreement Generated Date</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Enter agreement generated date'
            ></i>
          </label>
          <DatePicker
            className='form-control form-control-md form-control-solid py-2 px-6'
            autoComplete='off'
            selected={agreementGeneratedDate}
            dateFormat='yyyy/MM/dd'
            placeholderText='Enter agreement generated date'
            onChange={(date: Date) => {
              formik.setFieldTouched('agreement_generated_date', true, true)
              if (date === null) {
                setAgreementGeneratedDate(date)
                formik.setFieldValue('agreement_generated_date', '')
              } else {
                setAgreementGeneratedDate(date)
                formik.setFieldValue('agreement_generated_date', formatDate(date))
              }
            }}
          />
          <div className='h-20px'>
            {formik.touched.agreement_generated_date && formik.errors.agreement_generated_date && (
              <div className='fv-help-block color-red'>
                {formik.errors.agreement_generated_date}
              </div>
            )}
          </div>
        </div>
        {/*end::Form Group Agreement Generated Date*/}
        {/*Begin::Form Group Agreement Start Date*/}
        <div className={`fv-row mb-2 ${styles.max_w_48}`}>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span className='required'>Agreement Start Date</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Enter agreement start date'
            ></i>
          </label>
          <DatePicker
            className='form-control form-control-md form-control-solid py-2 px-6'
            autoComplete='off'
            selected={agreementStartDate}
            dateFormat='yyyy/MM/dd'
            placeholderText='Enter agreement start date'
            selectsStart
            startDate={agreementStartDate}
            endDate={agreementEndDate}
            maxDate={agreementEndDate}
            onChange={(date: Date) => {
              formik.setFieldTouched('rent_agreement_start_date', true, true)
              if (date === null) {
                setAgreementStartDate(date)
                formik.setFieldValue('rent_agreement_start_date', '')
              } else {
                setAgreementStartDate(date)
                formik.setFieldValue('rent_agreement_start_date', formatDate(date))
              }
            }}
          />
          <div className='h-20px'>
            {formik.touched.rent_agreement_start_date &&
              formik.errors.rent_agreement_start_date && (
                <div className='fv-help-block color-red'>
                  {formik.errors.rent_agreement_start_date}
                </div>
              )}
          </div>
        </div>
        {/*end::Form Group Agreement Start Date*/}
        {/*Begin::Form Group rent agreement end date*/}
        <div className={`fv-row mb-2 ${styles.max_w_48}`}>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span className='required'>Agreement End Date</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Enter agreement end date'
            ></i>
          </label>
          <DatePicker
            className='form-control form-control-md form-control-solid py-2 px-6'
            autoComplete='off'
            selected={agreementEndDate}
            dateFormat='yyyy/MM/dd'
            placeholderText='Enter agreement end date'
            selectsEnd
            startDate={agreementStartDate}
            endDate={agreementEndDate}
            minDate={agreementStartDate}
            onChange={(date) => {
              formik.setFieldTouched('rent_agreement_end_date', true, true)
              if (date === null) {
                setAgreementEndDate(date)
                formik.setFieldValue('rent_agreement_end_date', '')
              } else {
                setAgreementEndDate(date)
                formik.setFieldValue('rent_agreement_end_date', formatDate(date))
              }
            }}
          />
          <div className='h-20px'>
            {formik.touched.rent_agreement_end_date && formik.errors.rent_agreement_end_date && (
              <div className='fv-help-block color-red'>{formik.errors.rent_agreement_end_date}</div>
            )}
          </div>
        </div>
        {/*end::Form Group rent agreement end date*/}
        {/*Begin::Form Group Agreement Generated City*/}
        <div className={`fv-row mb-2 ${styles.max_w_48}`}>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span className='required'>Agreement Generated City</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Enter agreement generated city'
            ></i>
          </label>
          <input
            type='text'
            className='form-control form-control-lg form-control-solid'
            placeholder='Enter agreement generated city'
            {...formik.getFieldProps('agreement_generated_city')}
            name='agreement_generated_city'
          />
          <div className='h-20px'>
            {formik.touched.agreement_generated_city && formik.errors.agreement_generated_city && (
              <div className='fv-help-block color-red'>
                {formik.errors.agreement_generated_city}
              </div>
            )}
          </div>
        </div>
        {/*end::Form Group Agreement Generated City*/}
        {/*Begin::Form Group agreement jurisdiction city*/}
        <div className={`fv-row mb-2 ${styles.max_w_48}`}>
          <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
            <span className='required'>Agreement Jurisdiction City</span>
            <i
              className='fas fa-exclamation-circle ms-2 fs-7'
              data-bs-toggle='tooltip'
              title='Enter agreement jurisdiction city'
            ></i>
          </label>
          <input
            type='text'
            className='form-control form-control-lg form-control-solid'
            placeholder='Enter agreement jurisdiction city'
            {...formik.getFieldProps('agreement_jurisdiction_city')}
            name='agreement_jurisdiction_city'
          />
          <div className='h-20px'>
            {formik.touched.agreement_jurisdiction_city &&
              formik.errors.agreement_jurisdiction_city && (
                <div className='fv-help-block color-red'>
                  {formik.errors.agreement_jurisdiction_city}
                </div>
              )}
          </div>
        </div>
        {/*end::Form Group agreement jurisdiction city*/}
      </div>
      {/* End: Rent and Agreement Details */}

      <hr className='py-2 text-primary' />

      <div className='collapse show'>
        <div className='card-body px-2 pt-0 pb-10 fv-row'>
          <h2 className='text-center page-heading text-primary fw-bold fs-3 mb-5 pb-2'>
            Signers Details
          </h2>
          <div className='row'>
            <div className='col-lg-6 mb-5'>
              <div className='border border-1 border-primary border-dashed rounded p-3 px-5 position-relative'>
                {/* Begin: Lessor */}
                <div className='mb-1 '>
                  <span className='text-dark fw-bolder d-block fs-4 mb-2'>Lessor</span>
                  <hr className='py-2 text-primary' />
                  {/*Begin::Form Group Lessor Name*/}
                  <div className='fv-row d-flex justify-content-between w-100 flex-wrap'>
                    {/*Begin::Form Group lessor courtesy titles */}
                    <div className={`fv-row mb-2 ${styles.max_w_24}`}>
                      <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                        <span className='required'>Title</span>
                      </label>
                      <select
                        className='form-select form-select-solid px-3'
                        placeholder='Enter account holder courtesy title'
                        {...formik.getFieldProps('lessor_courtesy_titles')}
                        name='lessor_courtesy_titles'
                      >
                        <option className='bg-color-gray' value=''>
                          Select
                        </option>
                        <option value='Miss'>Miss</option>
                        <option value='Mr'>Mr</option>
                        <option value='Mrs'>Mrs</option>
                        <option value='Ms'>Ms</option>
                        <option value='Mx'>Mx</option>
                      </select>
                      <div className='h-20px'>
                        {formik.touched.lessor_courtesy_titles &&
                          formik.errors.lessor_courtesy_titles && (
                            <div className='fv-help-block color-red'>
                              {formik.errors.lessor_courtesy_titles}
                            </div>
                          )}
                      </div>
                    </div>
                    {/*end::Form Group lessor courtesy titles */}
                    {/*Begin::Form Group Lessor Full Name */}
                    <div className={`fv-row mb-2 ${styles.max_w_75}`}>
                      <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                        <span className='required'>Lessor Full Name</span>
                        <i
                          className='fas fa-exclamation-circle ms-2 fs-7'
                          data-bs-toggle='tooltip'
                          title='Enter lessor full name'
                        ></i>
                      </label>
                      <input
                        type='text'
                        className='form-control form-control-lg form-control-solid'
                        placeholder='Enter lessor full name'
                        {...formik.getFieldProps('lessor_full_name')}
                        name='lessor_full_name'
                      />
                      <div className='h-20px'>
                        {formik.touched.lessor_full_name && formik.errors.lessor_full_name && (
                          <div className='fv-help-block color-red'>
                            {formik.errors.lessor_full_name}
                          </div>
                        )}
                      </div>
                    </div>
                    {/*end::Form Group Lessor Full Name */}
                  </div>
                  {/*End::Form Group Lessor Name*/}
                  {/*Begin::Form Group agreement lessor age*/}
                  <div className='fv-row ml-8'>
                    <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                      <span className='required'>Lessor Age</span>
                      <i
                        className='fas fa-exclamation-circle ms-2 fs-7'
                        data-bs-toggle='tooltip'
                        title='Enter lessor age'
                      ></i>
                    </label>
                    <input
                      type='text'
                      className='form-control form-control-lg form-control-solid'
                      placeholder='Enter lessor age'
                      {...formik.getFieldProps('lessor_age')}
                      name='lessor_age'
                    />
                    <div className='h-20px'>
                      {formik.touched.lessor_age && formik.errors.lessor_age && (
                        <div className='fv-help-block color-red'>{formik.errors.lessor_age}</div>
                      )}
                    </div>
                  </div>
                  {/*end::Form Group agreement lessor age*/}
                  {/*Begin::Form Group lessor_address_1 */}
                  <div className='fv-row ml-8'>
                    <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                      <span className='required'>Address Line 1</span>
                      <i
                        className='fas fa-exclamation-circle ms-2 fs-7'
                        data-bs-toggle='tooltip'
                        title="Enter lessor's address"
                      ></i>
                    </label>
                    <textarea
                      className='form-control form-control-lg form-control-solid'
                      placeholder='Enter address'
                      {...formik.getFieldProps('lessor_address_1')}
                      name='lessor_address_1'
                    />
                    <div className='h-20px'>
                      {formik.touched.lessor_address_1 && formik.errors.lessor_address_1 && (
                        <div className='fv-help-block color-red'>
                          {formik.errors.lessor_address_1}
                        </div>
                      )}
                    </div>
                  </div>
                  {/*end::Form Group lessor_address_1 */}
                  {/*Begin::Form Group lessor_address_2 */}
                  <div className='fv-row ml-8'>
                    <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                      <span className='required'>Address Line 2</span>
                      <i
                        className='fas fa-exclamation-circle ms-2 fs-7'
                        data-bs-toggle='tooltip'
                        title="Enter lessor's address"
                      ></i>
                    </label>
                    <textarea
                      className='form-control form-control-lg form-control-solid'
                      placeholder='Enter address'
                      {...formik.getFieldProps('lessor_address_2')}
                      name='lessor_address_2'
                    />
                    <div className='h-20px'>
                      {formik.touched.lessor_address_2 && formik.errors.lessor_address_2 && (
                        <div className='fv-help-block color-red'>
                          {formik.errors.lessor_address_2}
                        </div>
                      )}
                    </div>
                  </div>
                  {/*end::Form Group lessor_address_2 */}
                  {/*Begin::Form Group lessor_address_city*/}
                  <div className='fv-row ml-8'>
                    <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                      <span className='required'>City</span>
                      <i
                        className='fas fa-exclamation-circle ms-2 fs-7'
                        data-bs-toggle='tooltip'
                        title="Enter lessor's city"
                      ></i>
                    </label>
                    <input
                      type='text'
                      className='form-control form-control-lg form-control-solid'
                      placeholder='Enter city'
                      {...formik.getFieldProps('lessor_address_city')}
                      name='lessor_address_city'
                    />
                    <div className='h-20px'>
                      {formik.touched.lessor_address_city && formik.errors.lessor_address_city && (
                        <div className='fv-help-block color-red'>
                          {formik.errors.lessor_address_city}
                        </div>
                      )}
                    </div>
                  </div>
                  {/*End::Form Group lessor_address_city*/}
                  {/*Begin::Form Group lessor_address_state*/}
                  <div className='fv-row ml-8'>
                    <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                      <span className='required'>Province/State</span>
                      <i
                        className='fas fa-exclamation-circle ms-2 fs-7'
                        data-bs-toggle='tooltip'
                        title="Choose lessor's province/state"
                      ></i>
                    </label>
                    <select
                      className='form-select form-select-solid'
                      placeholder='Select province/state'
                      {...formik.getFieldProps('lessor_address_state')}
                      name='lessor_address_state'
                    >
                      <option className='bg-color-gray' value=''>
                        Select province/state
                      </option>
                      {province.map((item) => {
                        return (
                          <option key={item.province_id} value={item.province_name}>
                            {item.province_name}
                          </option>
                        )
                      })}
                    </select>
                    <div className='h-20px'>
                      {formik.touched.lessor_address_state &&
                        formik.errors.lessor_address_state && (
                          <div className='fv-help-block color-red'>
                            {formik.errors.lessor_address_state}
                          </div>
                        )}
                    </div>
                  </div>
                  {/*end::Form Group lessor_address_state*/}
                  {/*Begin::Form Group lessor_address_pincode*/}
                  <div className='fv-row ml-8'>
                    <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                      <span className='required'>Pincode</span>
                      <i
                        className='fas fa-exclamation-circle ms-2 fs-7'
                        data-bs-toggle='tooltip'
                        title="Enter lessor's pincode"
                      ></i>
                    </label>
                    <input
                      type='text'
                      className='form-control form-control-lg form-control-solid'
                      placeholder='Enter pincode'
                      {...formik.getFieldProps('lessor_address_pincode')}
                      name='lessor_address_pincode'
                    />
                    <div className='h-20px'>
                      {formik.touched.lessor_address_pincode &&
                        formik.errors.lessor_address_pincode && (
                          <div className='fv-help-block color-red'>
                            {formik.errors.lessor_address_pincode}
                          </div>
                        )}
                    </div>
                  </div>
                  {/*End::Form Group lessor_address_pincode*/}
                  {/*Begin::Form Group lessor_pan*/}
                  <div className='fv-row ml-8'>
                    <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                      <span className='required'>PAN Number</span>
                      <i
                        className='fas fa-exclamation-circle ms-2 fs-7'
                        data-bs-toggle='tooltip'
                        title="Enter lessor's PAN number"
                      ></i>
                    </label>
                    <input
                      type='text'
                      className='form-control form-control-lg form-control-solid'
                      placeholder='Enter PAN number'
                      {...formik.getFieldProps('lessor_pan')}
                      name='lessor_pan'
                    />
                    <div className='h-20px'>
                      {formik.touched.lessor_pan && formik.errors.lessor_pan && (
                        <div className='fv-help-block color-red'>{formik.errors.lessor_pan}</div>
                      )}
                    </div>
                  </div>
                  {/*End::Form Group lessor_pan*/}
                </div>
                {/* End: Lessor */}
              </div>
            </div>
            <div className='col-lg-6 mb-5'>
              <div className='border border-1 border-primary border-dashed rounded p-3 px-7 position-relative'>
                {/* Begin: Lessee */}
                <div className='mb-1 '>
                  <span className='text-dark fw-bolder d-block fs-4 mb-2'>Lessee</span>
                  <hr className='py-2 text-primary' />
                  {/*Begin::Form Group Lessee Name*/}
                  <div className='fv-row d-flex justify-content-between w-100 flex-wrap'>
                    {/*Begin::Form Group lessee courtesy titles */}
                    <div className={`fv-row mb-2 ${styles.max_w_24}`}>
                      <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                        <span className='required'>Title</span>
                      </label>
                      <select
                        className='form-select form-select-solid px-3'
                        placeholder='Enter account holder courtesy title'
                        {...formik.getFieldProps('lessee_courtesy_titles')}
                        name='lessee_courtesy_titles'
                      >
                        <option className='bg-color-gray' value=''>
                          Select
                        </option>
                        <option value='Miss'>Miss</option>
                        <option value='Mr'>Mr</option>
                        <option value='Mrs'>Mrs</option>
                        <option value='Ms'>Ms</option>
                        <option value='Mx'>Mx</option>
                      </select>
                      <div className='h-20px'>
                        {formik.touched.lessee_courtesy_titles &&
                          formik.errors.lessee_courtesy_titles && (
                            <div className='fv-help-block color-red'>
                              {formik.errors.lessee_courtesy_titles}
                            </div>
                          )}
                      </div>
                    </div>
                    {/*end::Form Group lessee courtesy titles */}
                    {/*Begin::Form Group Lessee Full Name */}
                    <div className={`fv-row mb-2 ${styles.max_w_75}`}>
                      <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                        <span className='required'>Lessee Full Name</span>
                        <i
                          className='fas fa-exclamation-circle ms-2 fs-7'
                          data-bs-toggle='tooltip'
                          title='Enter lessee full name'
                        ></i>
                      </label>
                      <input
                        type='text'
                        className='form-control form-control-lg form-control-solid'
                        placeholder='Enter lessee full name'
                        {...formik.getFieldProps('lessee_full_name')}
                        name='lessee_full_name'
                      />
                      <div className='h-20px'>
                        {formik.touched.lessee_full_name && formik.errors.lessee_full_name && (
                          <div className='fv-help-block color-red'>
                            {formik.errors.lessee_full_name}
                          </div>
                        )}
                      </div>
                    </div>
                    {/*end::Form Group Lessee Full Name */}
                  </div>
                  {/*End::Form Group Lessee Name*/}
                  {/*Begin::Form Group agreement lessee age*/}
                  <div className='fv-row ml-8'>
                    <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                      <span className='required'>Lessee Age</span>
                      <i
                        className='fas fa-exclamation-circle ms-2 fs-7'
                        data-bs-toggle='tooltip'
                        title='Enter lessee age'
                      ></i>
                    </label>
                    <input
                      type='text'
                      className='form-control form-control-lg form-control-solid'
                      placeholder='Enter lessee age'
                      {...formik.getFieldProps('lessee_age')}
                      name='lessee_age'
                    />
                    <div className='h-20px'>
                      {formik.touched.lessee_age && formik.errors.lessee_age && (
                        <div className='fv-help-block color-red'>{formik.errors.lessee_age}</div>
                      )}
                    </div>
                  </div>
                  {/*end::Form Group agreement lessee age*/}
                  {/*Begin::Form Group lessee_address_1 */}
                  <div className='fv-row ml-8'>
                    <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                      <span className='required'>Address Line 1</span>
                      <i
                        className='fas fa-exclamation-circle ms-2 fs-7'
                        data-bs-toggle='tooltip'
                        title="Enter lessee's address"
                      ></i>
                    </label>
                    <textarea
                      className='form-control form-control-lg form-control-solid'
                      placeholder='Enter address'
                      {...formik.getFieldProps('lessee_address_1')}
                      name='lessee_address_1'
                    />
                    <div className='h-20px'>
                      {formik.touched.lessee_address_1 && formik.errors.lessee_address_1 && (
                        <div className='fv-help-block color-red'>
                          {formik.errors.lessee_address_1}
                        </div>
                      )}
                    </div>
                  </div>
                  {/*end::Form Group lessee_address_1 */}
                  {/*Begin::Form Group lessee_address_2 */}
                  <div className='fv-row ml-8'>
                    <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                      <span className='required'>Address Line 2</span>
                      <i
                        className='fas fa-exclamation-circle ms-2 fs-7'
                        data-bs-toggle='tooltip'
                        title="Enter lessee's address"
                      ></i>
                    </label>
                    <textarea
                      className='form-control form-control-lg form-control-solid'
                      placeholder='Enter address'
                      {...formik.getFieldProps('lessee_address_2')}
                      name='lessee_address_2'
                    />
                    <div className='h-20px'>
                      {formik.touched.lessee_address_2 && formik.errors.lessee_address_2 && (
                        <div className='fv-help-block color-red'>
                          {formik.errors.lessee_address_2}
                        </div>
                      )}
                    </div>
                  </div>
                  {/*end::Form Group lessee_address_2 */}
                  {/*Begin::Form Group lessee_address_city*/}
                  <div className='fv-row ml-8'>
                    <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                      <span className='required'>City</span>
                      <i
                        className='fas fa-exclamation-circle ms-2 fs-7'
                        data-bs-toggle='tooltip'
                        title="Enter lessee's city"
                      ></i>
                    </label>
                    <input
                      type='text'
                      className='form-control form-control-lg form-control-solid'
                      placeholder='Enter city'
                      {...formik.getFieldProps('lessee_address_city')}
                      name='lessee_address_city'
                    />
                    <div className='h-20px'>
                      {formik.touched.lessee_address_city && formik.errors.lessee_address_city && (
                        <div className='fv-help-block color-red'>
                          {formik.errors.lessee_address_city}
                        </div>
                      )}
                    </div>
                  </div>
                  {/*End::Form Group lessee_address_city*/}
                  {/*Begin::Form Group lessee_address_state*/}
                  <div className='fv-row ml-8'>
                    <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                      <span className='required'>Province/State</span>
                      <i
                        className='fas fa-exclamation-circle ms-2 fs-7'
                        data-bs-toggle='tooltip'
                        title="Choose lessee's province/state"
                      ></i>
                    </label>
                    <select
                      className='form-select form-select-solid'
                      placeholder='Select province/state'
                      {...formik.getFieldProps('lessee_address_state')}
                      name='lessee_address_state'
                    >
                      <option className='bg-color-gray' value=''>
                        Select province/state
                      </option>
                      {province.map((item) => {
                        return (
                          <option key={item.province_id} value={item.province_name}>
                            {item.province_name}
                          </option>
                        )
                      })}
                    </select>
                    <div className='h-20px'>
                      {formik.touched.lessee_address_state &&
                        formik.errors.lessee_address_state && (
                          <div className='fv-help-block color-red'>
                            {formik.errors.lessee_address_state}
                          </div>
                        )}
                    </div>
                  </div>
                  {/*end::Form Group lessee_address_state*/}
                  {/*Begin::Form Group lessee_address_pincode*/}
                  <div className='fv-row ml-8'>
                    <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                      <span className='required'>Pincode</span>
                      <i
                        className='fas fa-exclamation-circle ms-2 fs-7'
                        data-bs-toggle='tooltip'
                        title="Enter lessee's pincode"
                      ></i>
                    </label>
                    <input
                      type='text'
                      className='form-control form-control-lg form-control-solid'
                      placeholder='Enter pincode'
                      {...formik.getFieldProps('lessee_address_pincode')}
                      name='lessee_address_pincode'
                    />
                    <div className='h-20px'>
                      {formik.touched.lessee_address_pincode &&
                        formik.errors.lessee_address_pincode && (
                          <div className='fv-help-block color-red'>
                            {formik.errors.lessee_address_pincode}
                          </div>
                        )}
                    </div>
                  </div>
                  {/*End::Form Group lessee_address_pincode*/}
                  {/*Begin::Form Group lessee_pan*/}
                  <div className='fv-row ml-8'>
                    <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                      <span className='required'>PAN Number</span>
                      <i
                        className='fas fa-exclamation-circle ms-2 fs-7'
                        data-bs-toggle='tooltip'
                        title="Enter lessee's PAN number"
                      ></i>
                    </label>
                    <input
                      type='text'
                      className='form-control form-control-lg form-control-solid'
                      placeholder='Enter PAN number'
                      {...formik.getFieldProps('lessee_pan')}
                      name='lessee_pan'
                    />
                    <div className='h-20px'>
                      {formik.touched.lessee_pan && formik.errors.lessee_pan && (
                        <div className='fv-help-block color-red'>{formik.errors.lessee_pan}</div>
                      )}
                    </div>
                  </div>
                  {/*End::Form Group lessee_pan*/}
                  {/*Begin::Form Group lessee_mobiles*/}
                  <div className='fv-row ml-8'>
                    <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                      <span className='required'>Mobile number</span>
                      <i
                        className='fas fa-exclamation-circle ms-2 fs-7'
                        data-bs-toggle='tooltip'
                        title="Enter lessee's mobile number"
                      ></i>
                    </label>
                    <MuiPhoneNumber
                      {...formik.getFieldProps(`lessee_mobiles`)}
                      className='w-100 pt-2 pb-1'
                      defaultCountry={'in'}
                      onChange={(value: string) => formik.setFieldValue(`lessee_mobiles`, value)}
                    />
                    <div className='h-20px'>
                      {formik.touched.lessee_mobiles && formik.errors.lessee_mobiles && (
                        <div className='fv-help-block color-red'>
                          {formik.errors.lessee_mobiles}
                        </div>
                      )}
                    </div>
                  </div>
                  {/*End::Form Group lessee_mobiles*/}
                  {/*Begin::Form Group lessee_email_id*/}
                  <div className='fv-row ml-8'>
                    <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                      <span className='required'>Email Address</span>
                      <i
                        className='fas fa-exclamation-circle ms-2 fs-7'
                        data-bs-toggle='tooltip'
                        title="Enter lessee's email address"
                      ></i>
                    </label>
                    <input
                      type='text'
                      className='form-control form-control-lg form-control-solid'
                      placeholder='Enter email address'
                      {...formik.getFieldProps('lessee_email_id')}
                      name='lessee_email_id'
                    />
                    <div className='h-20px'>
                      {formik.touched.lessee_email_id && formik.errors.lessee_email_id && (
                        <div className='fv-help-block color-red'>
                          {formik.errors.lessee_email_id}
                        </div>
                      )}
                    </div>
                  </div>
                  {/*End::Form Group lessee_email_id*/}
                  {/*Begin::Form Group lessee_aadhar*/}
                  <div className='fv-row ml-8'>
                    <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                      <span className='required'>Aadhar Number</span>
                      <i
                        className='fas fa-exclamation-circle ms-2 fs-7'
                        data-bs-toggle='tooltip'
                        title="Enter lessee's aadhar number"
                      ></i>
                    </label>
                    <input
                      type='text'
                      className='form-control form-control-lg form-control-solid'
                      placeholder='Enter aadhar number'
                      {...formik.getFieldProps('lessee_aadhar')}
                      name='lessee_aadhar'
                    />
                    <div className='h-20px'>
                      {formik.touched.lessee_aadhar && formik.errors.lessee_aadhar && (
                        <div className='fv-help-block color-red'>{formik.errors.lessee_aadhar}</div>
                      )}
                    </div>
                  </div>
                  {/*End::Form Group lessee_aadhar*/}
                </div>
                {/* End: Lessee */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr className='py-2 text-primary' />
      <div className='collapse show'>
        <div className='card-body px-9 pt-0 pb-5 fv-row'>
          <div className='d-flex justify-content-center'>
            <h2 className='text-center page-heading text-primary fw-bold fs-3 mb-5 pb-2'>
              Witnesses Details
            </h2>
            <span className='mb-2 text-primary'>&nbsp;(optional)</span>
          </div>
          <div className='row'>
            {/* Begin: Witness 1 */}
            <div className='col-lg-6 mb-5'>
              <div className='border border-1 border-primary border-dashed rounded p-3 px-7 position-relative'>
                <div className='mb-1 '>
                  <span className='text-dark fw-bolder d-block fs-4 mb-2'>Witness 1</span>
                  <hr className='py-2 text-primary' />
                  {/*Begin::Form Group witness1_address_1 */}
                  <div className='fv-row ml-8'>
                    <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                      <span>Address Line 1</span>
                      <i
                        className='fas fa-exclamation-circle ms-2 fs-7'
                        data-bs-toggle='tooltip'
                        title='Enter witness address'
                      ></i>
                    </label>
                    <textarea
                      className='form-control form-control-lg form-control-solid'
                      placeholder='Enter address'
                      {...formik.getFieldProps('witness1_address_1')}
                      name='witness1_address_1'
                    />
                    <div className='h-20px'>
                      {formik.touched.witness1_address_1 && formik.errors.witness1_address_1 && (
                        <div className='fv-help-block color-red'>
                          {formik.errors.witness1_address_1}
                        </div>
                      )}
                    </div>
                  </div>
                  {/*end::Form Group witness1_address_1 */}
                  {/*Begin::Form Group witness1_address_2 */}
                  <div className='fv-row ml-8'>
                    <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                      <span>Address Line 2</span>
                      <i
                        className='fas fa-exclamation-circle ms-2 fs-7'
                        data-bs-toggle='tooltip'
                        title='Enter witness address'
                      ></i>
                    </label>
                    <textarea
                      className='form-control form-control-lg form-control-solid'
                      placeholder='Enter address'
                      {...formik.getFieldProps('witness1_address_2')}
                      name='witness1_address_2'
                    />
                    <div className='h-20px'>
                      {formik.touched.witness1_address_2 && formik.errors.witness1_address_2 && (
                        <div className='fv-help-block color-red'>
                          {formik.errors.witness1_address_2}
                        </div>
                      )}
                    </div>
                  </div>
                  {/*end::Form Group witness1_address_2 */}
                  {/*Begin::Form Group witness1_address_city*/}
                  <div className='fv-row ml-8'>
                    <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                      <span>City</span>
                      <i
                        className='fas fa-exclamation-circle ms-2 fs-7'
                        data-bs-toggle='tooltip'
                        title='Enter witness city'
                      ></i>
                    </label>
                    <input
                      type='text'
                      className='form-control form-control-lg form-control-solid'
                      placeholder='Enter city'
                      {...formik.getFieldProps('witness1_address_city')}
                      name='witness1_address_city'
                    />
                    <div className='h-20px'>
                      {formik.touched.witness1_address_city &&
                        formik.errors.witness1_address_city && (
                          <div className='fv-help-block color-red'>
                            {formik.errors.witness1_address_city}
                          </div>
                        )}
                    </div>
                  </div>
                  {/*End::Form Group witness1_address_city*/}
                  {/*Begin::Form Group witness1_address_state*/}
                  <div className='fv-row ml-8'>
                    <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                      <span>Province/State</span>
                      <i
                        className='fas fa-exclamation-circle ms-2 fs-7'
                        data-bs-toggle='tooltip'
                        title='Choose witness province/state'
                      ></i>
                    </label>
                    <select
                      className='form-select form-select-solid'
                      placeholder='Select province/state'
                      {...formik.getFieldProps('witness1_address_state')}
                      name='witness1_address_state'
                    >
                      <option className='bg-color-gray' value=''>
                        Select province/state
                      </option>
                      {province.map((item) => {
                        return (
                          <option key={item.province_id} value={item.province_name}>
                            {item.province_name}
                          </option>
                        )
                      })}
                    </select>
                    <div className='h-20px'>
                      {formik.touched.witness1_address_state &&
                        formik.errors.witness1_address_state && (
                          <div className='fv-help-block color-red'>
                            {formik.errors.witness1_address_state}
                          </div>
                        )}
                    </div>
                  </div>
                  {/*end::Form Group witness1_address_state*/}
                  {/*Begin::Form Group witness1_address_pincode*/}
                  <div className='fv-row ml-8'>
                    <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                      <span>Pincode</span>
                      <i
                        className='fas fa-exclamation-circle ms-2 fs-7'
                        data-bs-toggle='tooltip'
                        title='Enter witness pincode'
                      ></i>
                    </label>
                    <input
                      type='text'
                      className='form-control form-control-lg form-control-solid'
                      placeholder='Enter pincode'
                      {...formik.getFieldProps('witness1_address_pincode')}
                      name='witness1_address_pincode'
                    />
                    <div className='h-20px'>
                      {formik.touched.witness1_address_pincode &&
                        formik.errors.witness1_address_pincode && (
                          <div className='fv-help-block color-red'>
                            {formik.errors.witness1_address_pincode}
                          </div>
                        )}
                    </div>
                  </div>
                  {/*End::Form Group witness1_address_pincode*/}
                </div>
              </div>
            </div>
            {/* End: Witness 1 */}
            {/* Begin: Witness 2 */}
            <div className='col-lg-6 mb-5'>
              <div className='border border-1 border-primary border-dashed rounded p-3 px-7 position-relative'>
                <div className='mb-1 '>
                  <span className='text-dark fw-bolder d-block fs-4 mb-2'>Witness 2</span>
                  <hr className='py-2 text-primary' />
                  {/*Begin::Form Group witness2_address_1 */}
                  <div className='fv-row ml-8'>
                    <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                      <span>Address Line 1</span>
                      <i
                        className='fas fa-exclamation-circle ms-2 fs-7'
                        data-bs-toggle='tooltip'
                        title='Enter witness address'
                      ></i>
                    </label>
                    <textarea
                      className='form-control form-control-lg form-control-solid'
                      placeholder='Enter address'
                      {...formik.getFieldProps('witness2_address_1')}
                      name='witness2_address_1'
                    />
                    <div className='h-20px'>
                      {formik.touched.witness2_address_1 && formik.errors.witness2_address_1 && (
                        <div className='fv-help-block color-red'>
                          {formik.errors.witness2_address_1}
                        </div>
                      )}
                    </div>
                  </div>
                  {/*end::Form Group witness2_address_1 */}
                  {/*Begin::Form Group witness2_address_2 */}
                  <div className='fv-row ml-8'>
                    <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                      <span>Address Line 2</span>
                      <i
                        className='fas fa-exclamation-circle ms-2 fs-7'
                        data-bs-toggle='tooltip'
                        title='Enter witness address'
                      ></i>
                    </label>
                    <textarea
                      className='form-control form-control-lg form-control-solid'
                      placeholder='Enter address'
                      {...formik.getFieldProps('witness2_address_2')}
                      name='witness2_address_2'
                    />
                    <div className='h-20px'>
                      {formik.touched.witness2_address_2 && formik.errors.witness2_address_2 && (
                        <div className='fv-help-block color-red'>
                          {formik.errors.witness2_address_2}
                        </div>
                      )}
                    </div>
                  </div>
                  {/*end::Form Group witness2_address_2 */}
                  {/*Begin::Form Group witness2_address_city*/}
                  <div className='fv-row ml-8'>
                    <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                      <span>City</span>
                      <i
                        className='fas fa-exclamation-circle ms-2 fs-7'
                        data-bs-toggle='tooltip'
                        title='Enter witness city'
                      ></i>
                    </label>
                    <input
                      type='text'
                      className='form-control form-control-lg form-control-solid'
                      placeholder='Enter city'
                      {...formik.getFieldProps('witness2_address_city')}
                      name='witness2_address_city'
                    />
                    <div className='h-20px'>
                      {formik.touched.witness2_address_city &&
                        formik.errors.witness2_address_city && (
                          <div className='fv-help-block color-red'>
                            {formik.errors.witness2_address_city}
                          </div>
                        )}
                    </div>
                  </div>
                  {/*End::Form Group witness2_address_city*/}
                  {/*Begin::Form Group witness2_address_state*/}
                  <div className='fv-row ml-8'>
                    <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                      <span>Province/State</span>
                      <i
                        className='fas fa-exclamation-circle ms-2 fs-7'
                        data-bs-toggle='tooltip'
                        title='Choose witness province/state'
                      ></i>
                    </label>
                    <select
                      className='form-select form-select-solid'
                      placeholder='Select province/state'
                      {...formik.getFieldProps('witness2_address_state')}
                      name='witness2_address_state'
                    >
                      <option className='bg-color-gray' value=''>
                        Select province/state
                      </option>
                      {province.map((item) => {
                        return (
                          <option key={item.province_id} value={item.province_name}>
                            {item.province_name}
                          </option>
                        )
                      })}
                    </select>
                    <div className='h-20px'>
                      {formik.touched.witness2_address_state &&
                        formik.errors.witness2_address_state && (
                          <div className='fv-help-block color-red'>
                            {formik.errors.witness2_address_state}
                          </div>
                        )}
                    </div>
                  </div>
                  {/*end::Form Group witness2_address_state*/}
                  {/*Begin::Form Group witness2_address_pincode*/}
                  <div className='fv-row ml-8'>
                    <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                      <span>Pincode</span>
                      <i
                        className='fas fa-exclamation-circle ms-2 fs-7'
                        data-bs-toggle='tooltip'
                        title='Enter witness pincode'
                      ></i>
                    </label>
                    <input
                      type='text'
                      className='form-control form-control-lg form-control-solid'
                      placeholder='Enter pincode'
                      {...formik.getFieldProps('witness2_address_pincode')}
                      name='witness2_address_pincode'
                    />
                    <div className='h-20px'>
                      {formik.touched.witness2_address_pincode &&
                        formik.errors.witness2_address_pincode && (
                          <div className='fv-help-block color-red'>
                            {formik.errors.witness2_address_pincode}
                          </div>
                        )}
                    </div>
                  </div>
                  {/*End::Form Group witness2_address_pincode*/}
                </div>
              </div>
            </div>
            {/* End: Witness 2 */}
          </div>
        </div>
      </div>
    </div>
  )
}

export default CreateAgreementStep2
